<template>
    <div class="py-3">
        <div class="container">
            <TravelExpenseReportTabs :linksDisabled=false :expenseReportID=expenseReportID></TravelExpenseReportTabs>
            <div class="row">
                <div class="col-md-12">
                    <h4 style="font-weight:900; margin-bottom:0px;">Review and Submit</h4>
                    <div class="my-1" style="margin-top:0px;">{{expenseReportStatusTypeName}}</div>
                    <label>Summary<br></label>
                </div>
                <table class="table table-borderless">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Category</th>
                            <th scope="col">Reimbursement</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th v-if="summaryCosts.airfareIsValid == null" scope="row" style="color:green" class="text-right"></th>
                            <th v-if="summaryCosts.airfareIsValid == true" scope="row" style="color:green" class="text-right">✓</th>
                            <th v-if="summaryCosts.airfareIsValid == false" scope="row" style="color:red" class="text-right">X</th>
                            <td><router-link :to="{ name: 'air', params: {erid: expenseReportID } }">Air</router-link></td>
                            <td>{{summaryCosts.airfareReimbursementAmount | currency}}</td>
                        </tr>
                        <tr>
                            <th v-if="summaryCosts.lodgingIsValid == null" scope="row" style="color:green" class="text-right"></th>
                            <th v-if="summaryCosts.lodgingIsValid == true" scope="row" style="color:green" class="text-right">✓</th>
                            <th v-if="summaryCosts.lodgingIsValid == false" scope="row" style="color:red" class="text-right">X</th>
                            <td><router-link :to="{ name: 'lodging', params: {erid: expenseReportID } }">Lodging</router-link></td>
                            <td>{{summaryCosts.lodgingReimbursementAmount | currency}}</td>
                        </tr>
                        <tr>
                            <th v-if="summaryCosts.mealIsValid == null" scope="row" style="color:green" class="text-right"></th>
                            <th v-if="summaryCosts.mealIsValid == true" scope="row" style="color:green" class="text-right">✓</th>
                            <th v-if="summaryCosts.mealIsValid == false" scope="row" style="color:red" class="text-right">X</th>
                            <td><router-link :to="{ name: 'meals', params: {erid: expenseReportID } }">Meals</router-link></td>
                            <td>{{summaryCosts.mealReimbursementAmount | currency}}</td>
                        </tr>
                        <tr>
                            <th v-if="summaryCosts.carRentalIsValid == null" scope="row" style="color:green" class="text-right"></th>
                            <th v-if="summaryCosts.carRentalIsValid == true" scope="row" style="color:green" class="text-right">✓</th>
                            <th v-if="summaryCosts.carRentalIsValid == false" scope="row" style="color:red" class="text-right">X</th>
                            <td><router-link :to="{ name: 'rental-car', params: {erid: expenseReportID } }">Rental Car</router-link></td>
                            <td>{{summaryCosts.carRentalReimbursementAmount | currency}}</td>
                        </tr>
                        <tr>
                            <th scope="row" style="color:green" class="text-right"></th>
                            <td><router-link :to="{ name: 'other', params: {erid: expenseReportID } }">Other</router-link></td>
                            <td></td>
                        </tr>
                        <tr>
                            <th v-if="summaryCosts.groundTransportationIsValid == null" scope="row" style="color:green" class="text-right"></th>
                            <th v-if="summaryCosts.groundTransportationIsValid == true" scope="row" style="color:green" class="text-right">✓</th>
                            <th v-if="summaryCosts.groundTransportationIsValid == false" scope="row" style="color:red" class="text-right">X</th>
                            <td class="pl-5"><router-link :to="{ name: 'other', params: {erid: expenseReportID } }">Ground Transportation</router-link></td>
                            <td>{{summaryCosts.groundTransportationReimbursementAmount | currency}}</td>
                        </tr>
                        <tr>
                            <th v-if="summaryCosts.personalVehicleMileageIsValid == null" scope="row" style="color:green" class="text-right"></th>
                            <th v-if="summaryCosts.personalVehicleMileageIsValid == true" scope="row" style="color:green" class="text-right">✓</th>
                            <th v-if="summaryCosts.personalVehicleMileageIsValid == false" scope="row" style="color:red" class="text-right">X</th>
                            <td class="pl-5"><router-link :to="{ name: 'other', params: {erid: expenseReportID } }">POV Mileage</router-link></td>
                            <td>{{summaryCosts.personalVehicleMileageReimbursementAmount | currency}}</td>
                        </tr>
                        <tr>
                            <th v-if="summaryCosts.miscCostIsValid == null" scope="row" style="color:green" class="text-right"></th>
                            <th v-if="summaryCosts.miscCostIsValid == true" scope="row" style="color:green" class="text-right">✓</th>
                            <th v-if="summaryCosts.miscCostIsValid == false" scope="row" style="color:red" class="text-right">X</th>
                            <td class="pl-5"><router-link :to="{ name: 'other', params: {erid: expenseReportID } }">Misc Costs</router-link></td>
                            <td>{{summaryCosts.miscCostReimbursementAmount | currency}}</td>
                        </tr>
                        <tr>
                            <th scope="row"></th>
                            <td>Total</td>
                            <td>{{summaryCosts.totalReimbursementAmount | currency}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <div class="alert alert-warning">
                                    <i class="fa fa-exclamation-triangle mr-1"></i>
                                    <em>Categories with an <span style="color:red; font-weight: bold">X</span> are not complete and must be addressed before submitting.</em>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-borderless">
                        <thead>
                            <tr>
                                <th scope="col">Project Allocation</th>
                                <th scope="col">
                                    <b-form-group>
                                        <b-form-radio-group size="sm" id="btn-radios-1"
                                                            @change="translateCurrencyToPercentOrDollars"
                                                            v-model="existingReview.isPercentAmountAllocation"
                                                            :options="currencyOptions"
                                                            buttons
                                                            name="radios-btn-default">
                                        </b-form-radio-group>
                                    </b-form-group>
                                    <!--<div class="btn-group btn-group-toggle" data-toggle="buttons">

                                    <label class="btn btn-secondary btn-sm active">$ </label>
                                    <label class="btn btn-secondary btn-sm" aria-pressed="false">% </label>
                                </div>-->
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(p,pAIndex) in existingReview.projectAmountAllocations">
                                <td>
                                    <b-form-select :options="projects" text-field="projectName" value-field="id" v-model="p.projectId">
                                        <option :value="null" disabled>Choose a project</option>
                                    </b-form-select>
                                    <router-link :to="{ name: 'project-users-edit', query: { 'returnExpenseReportID': expenseReportID } }">Assign new project</router-link>
                                </td>
                                <td>
                                    <input type="number" @focus="$event.target.select()" class="form-control" style="text-align:right;" v-model="p.allocationValue" />
                                    <div v-if="existingReview.isPercentAmountAllocation">
                                        {{parseFloat((p.allocationValue / 100) * summaryCosts.totalReimbursementAmount).toFixed(2)  | currency}}
                                    </div>
                                </td>
                                <td><button style="float:left" type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.ProjectType,pAIndex,null)"><span aria-hidden="true">&times;</span></button></td>
                            </tr>
                            <tr>
                                <!-- Add Button -->
                                <td>
                                    <button class="btn btn-secondary btn-sm" href="#" @click="addProjectToAllocationList()">Add Project</button>
                                </td>
                                <!-- Total -->
                                <td>
                                    <div v-if="existingReview.isPercentAmountAllocation == false" style="font-weight:bold;" v-bind:class="{ 'text-danger': isSumProjectAllocationNotEqualsTotal}">
                                        Total: <span v-if="!existingReview.isPercentAmountAllocation"></span>{{sumOfProjectAllocations | currency}} <span v-if="existingReview.isPercentAmountAllocation">%</span>
                                    </div>
                                    <div v-if="existingReview.isPercentAmountAllocation" style="font-weight:bold;" v-bind:class="{ 'text-danger': isSumProjectAllocationNotEqualsTotal}">
                                        Total: <span v-if="!existingReview.isPercentAmountAllocation">$</span>{{sumOfProjectAllocations.toFixed(2)}} <span v-if="existingReview.isPercentAmountAllocation">%</span>
                                    </div>
                                </td>
                                <!-- Empty -->
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <b-form-group label="Was any portion of this trip cancelled that also resulted in forfeited expenditures?">
                <b-form-radio-group size="sm" id="fec-1"
                                    v-model="existingReview.hasForfeitedExpenditureCancellation"
                                    :options="[{ text: 'Yes', value: true },{ text: 'No', value: false }]"
                                    name="fec-1">
                </b-form-radio-group>
            </b-form-group>

            <b-form-group v-if="existingReview.hasForfeitedExpenditureCancellation" label="Please explain">
                <b-form-textarea id="textarea"
                                 v-model="existingReview.forfeitedExpenditureCancellationComment"
                                 placeholder=""
                                 rows="1"
                                 max-rows="3">
                </b-form-textarea>
            </b-form-group>

            <b-form-group v-if="existingReview.hasForfeitedExpenditureCancellation" label="Where possible, were steps taken to minimize cancellation costs?">
                <b-form-radio-group size="sm" id="hmc-1"
                                    v-model="existingReview.hasMinimizeCosts"
                                    :options="[{ text: 'Yes', value: true },{ text: 'No', value: false }]"
                                    name="hmc-1">
                </b-form-radio-group>
            </b-form-group>

            <b-form-group v-if="existingReview.hasMinimizeCosts == false && existingReview.hasForfeitedExpenditureCancellation" label="Please explain">
                <b-form-textarea id="textarea"
                                 v-model="existingReview.hasMinimizeCostsComment"
                                 placeholder=""
                                 rows="1"
                                 max-rows="3">
                </b-form-textarea>
            </b-form-group>

            <div>
                <div style="font-weight:bold;">
                    Foreign currency conversion support <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'If actual exchange rates were used, and not included within the respective sections, attach corresponding support (e.g. bank/credit card statement) within “Additional Supporting Documents” attachment.'" icon="info-circle" />
                </div>
                <div>
                    For any receipts provided in foreign currency and not supported elsewhere. Please provide the
                    exchange rate used or a document supporting the US dollar amount required requested to be
                    reimbursed.  <a :href="summaryCosts.currencyExchangeRateUrl" target="_blank">
                        {{
summaryCosts.currencyExchangeRateUrl
                        }}
                    </a>
                </div>
                <br />

                <div v-for="(fEA,fEAIndex) in existingReview.foreignExchangeAmounts">
                    <b-form inline>
                        <div style="margin-top: 30px; margin-right: 5px;">$1 USD</div>
                        <b-form-group label="Foreign currency amount">
                            <b-input id="inline-form-input-name"
                                     class="mb-2 mr-sm-2 mb-sm-0"
                                     v-model="fEA.amount"
                                     placeholder="Enter amount"
                                     type="number">
                            </b-input>
                        </b-form-group>

                        <b-form-group label="Exchange rate used">
                            <b-form-select :options="currency" v-model="fEA.foreignCurrency">
                                <option :value="null" disabled>Choose an option</option>
                            </b-form-select>
                        </b-form-group>
                        <button type="button" class="close" style="margin-top: 20px;margin-left: 20px;" aria-label="Close" @click="showRemovalModal(ItemRemoveType.CurrencyAmount, fEAIndex,null)"><span aria-hidden="true">&times;</span></button>
                    </b-form>
                </div>
                <div class="form-group" style="margin-top:10px;">
                    <button class="btn btn-secondary btn-sm" @click="addCurrencyAmount()">Add currency amount</button>
                </div>

                <button class="btn btn-secondary btn-sm" type="button" @click="$bvModal.show('foreignExchangeAmountsAttachmentModal')">Add currency attachment</button>
                <b-modal id="foreignExchangeAmountsAttachmentModal" centered title="Add Attachment" :hide-footer=true>
                    <AttachmentComponent :expenseReportId="expenseReportID" :attachments="existingReview.foreignExchangeAttachments" @fileUploadDone="$bvModal.hide('foreignExchangeAmountsAttachmentModal')"></AttachmentComponent>
                </b-modal>

                <div style="cursor: pointer" v-for="(baa, baaIndex) in existingReview.foreignExchangeAttachments">
                    <span @click="downloadFileInNewWindow(baa)">{{baa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.ExchangeAttachment, baaIndex,null)">&times;</span>
                </div>

                <!--<b-form-group label="Foreign currency comment">

                <b-form-textarea id="textarea"
                                 placeholder=""
                                 rows="1"
                                 max-rows="6">
                </b-form-textarea>
            </b-form-group>-->

            </div>
            <br />
            <div class="form-group">
                <label for="exampleFormControlTextarea1">General Comments, if needed</label>
                <textarea v-model="existingReview.generalComment" class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
            </div>
            <p> Additional supporting documents </p>
            <!--<div class="form-group">

            <a class="btn btn-secondary btn-sm" href="#">Attach</a>
        </div>-->

            <div style="margin-bottom:25px;">
                <button class="btn btn-secondary btn-sm" type="button" @click="$bvModal.show('generalAttachmentsModal')">Attach</button>
                <b-modal id="generalAttachmentsModal" centered title="Add attachment" :hide-footer=true>
                    <AttachmentComponent :expenseReportId="expenseReportID" :attachments="existingReview.generalAttachments" @fileUploadDone="$bvModal.hide('generalAttachmentsModal')"></AttachmentComponent>
                </b-modal>
                <div style="cursor: pointer" v-for="(baa, baaIndex) in existingReview.generalAttachments">
                    <span @click="downloadFileInNewWindow(baa)">{{baa.attachmentName}}</span> <span @click="showRemovalModal(ItemRemoveType.GeneralAttachment,baaIndex,null)" aria-hidden="true">&times;</span>
                </div>
            </div>

            <div class="alert alert-warning" v-if="summaryCosts && summaryCosts.hasTripDateOutsideOneOrMoreProjectDates">
                <i class="fa fa-exclamation-triangle mr-1"></i>
                <em>Warning</em> - some of the costs fall outside of one or more of the allocated project's Period of Performance.
                <span v-if="expenseReportStatusTypeId == 1 || expenseReportStatusTypeId == 5 || expenseReportStatusTypeId == 6">Are you sure you want to submit?</span>
            </div>
            <div class="alert alert-warning" v-if="summaryCosts && summaryCosts.isSubmittedBeforeFinalTripDate">
                <i class="fa fa-exclamation-triangle mr-1"></i>
                <em>Warning</em> - expense report was submitted before the final day of the trip.
            </div>
            <button type="submit" class="btn btn-primary btn-lg mr-2" @click="save()">Save</button>
            <button v-if="expenseReportStatusTypeId == 1 || expenseReportStatusTypeId == 5 || expenseReportStatusTypeId == 6" type="submit" style="margin-right:10px;" class="btn btn-primary btn-lg" @click="submitReviewPreCheck()">Submit</button>
            <button v-if="expenseReportStatusTypeId == 2" type="submit" style="margin-right:10px;" class="btn btn-primary btn-lg" @click="submitApproval">PI Approve</button>
            <button v-if="expenseReportStatusTypeId == 3" type="submit" style="margin-right:10px;" class="btn btn-primary btn-lg" @click="submitApproval">Admin 1 Approve</button>
            <button v-if="expenseReportStatusTypeId == 4" type="submit" style="margin-right:10px;" class="btn btn-primary btn-lg" @click="submitApproval">Admin 2 Approve</button>
            <button v-if="expenseReportStatusTypeId == 2 || expenseReportStatusTypeId == 3 || expenseReportStatusTypeId == 4" type="submit" style="margin-right:10px;" class="btn btn-primary btn-lg" @click="deny">Send back to user</button>

        </div>
        <div class="container">
            <div class="row">
                <!--<div class="col-md-12">
                <h3>Approve / Dissapprove</h3>
                <textarea>Comment</textarea>
                <div @click="submitApproval">Approval Button</div>
                <div>Disapprove Button</div>
            </div>-->
                <!-- comment history comp -->
                <CommentsComponent v-if="expenseReportStatusTypeId > 1" :expenseReportID="expenseReportID" :area="'all'"></CommentsComponent>
                <div class="col-md-12" v-if="expenseReportStatusTypeId > 1">
                    <!-- audit history comp -->
                    <AuditHistoryComponent :expenseReportID="expenseReportID" :area="'all'"></AuditHistoryComponent>
                </div>
            </div>
        </div>
        <modal title="Confirm Delete?" :is-small="true" v-if="show_modal_remove" @close="show_modal = false">
            <div class="modal-body">
                Are you sure you want to remove this item?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="removeItem(itemTypeToRemove, itemToRemove, attachmentToRemove)">Delete</button>
                <button type="button" class="btn btn-primary" @click="show_modal_remove = false">Cancel</button>
            </div>
        </modal>
        <modal title="Successfully submitted" :is-small="true" v-if="show_modal" @close="show_modal = false">
            <div class="modal-body">
                Your expense report has been successfully submitted. Click ok to continue.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="$router.push('/')">Ok</button>
            </div>
        </modal>
        <b-modal id="confirm-submit-modal" centered title="Warning" :hide-footer="true">
            Some of the costs fall outside of one or more of the allocated project's Period of Performance. Are you sure you want to submit?
            <div class="d-flex align-items-center justify-content-end mt-2">
                <button type="button" class="btn btn-secondary" @click="hideConfirmModal()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary ml-1" @click="submitReview()">
                    Submit
                </button>
            </div>
        </b-modal>
        <modal title="Save progress?" :is-small="true" v-if="show_save_modal" @close="show_save_modal = false">
            <div class="modal-body">
                Save changes to expense report?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="save()">Save</button>
                <button type="button" class="btn btn-primary" @click="show_save_modal=false">Cancel</button>
            </div>
        </modal>
    </div>
</template>
<style scoped>

    .audit-section-header {
        font-weight: bold;
    }

    .snapshot-details {
        margin-left: 25px;
        margin-bottom: 5px;
    }

    .key-style {
        font-weight: 400;
    }
</style>
<script>
    // @ is an alias to /src
    import TravelExpenseReportTabs from '@/components/TravelExpenseReportTabs.vue'
    import modal from '@/components/modal.vue'
    import AuditHistoryComponent from '@/components/AuditHistoryComponent.vue'
    import AttachmentComponent from '@/components/AttachmentComponent.vue'
    import CommentsComponent from '@/components/CommentsComponent.vue'
    import ApprovalService from '@/services/ApprovalService'
    import TripProfileService from '@/services/TripProfileService'
    import ProjectService from '@/services/ProjectService'

    export default {
        name: 'review-submit',
        components: {
            TravelExpenseReportTabs,
            modal,
            AttachmentComponent,
            AuditHistoryComponent,
            CommentsComponent
        },
        async created() {
            if (this.$route.params.erid) {
                this.expenseReportID = this.$route.params.erid;
                this.getExisitingReview(this.expenseReportID)
                this.getSummaryCosts(this.expenseReportID);
                if (this.existingReview.projectAmountAllocations.length == 0) {
                    this.addProjectToAllocationList();
                }
                let response = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                this.expenseReportStatusTypeId = response.expenseReportStatusTypeId;
                this.expenseReportStatusTypeName = response.expenseReportStatusTypeName;
            }
        },
        computed: {
            sumOfProjectAllocations: function () {
                return _.sumBy(this.existingReview.projectAmountAllocations, function (pa) {
                    if (!pa.allocationValue) {
                        return 0;
                    }
                    return Number(pa.allocationValue);
                })
            },
            isSumProjectAllocationNotEqualsTotal: function () {
                if (this.existingReview.isPercentAmountAllocation) {
                    return this.sumOfProjectAllocations.toFixed(2) != 100;
                }
                if (this.summaryCosts.totalReimbursementAmount)
                    return this.sumOfProjectAllocations.toFixed(2) != this.summaryCosts.totalReimbursementAmount.toFixed(2);
                else
                    return false;
            },
            projectAllocationsDiff: function () {
                if (this.existingReview.isPercentAmountAllocation) {
                    return (100 - this.sumOfProjectAllocations).toFixed(2);
                }
                let result = this.summaryCosts.totalReimbursementAmount - this.sumOfProjectAllocations;
                result = result < 0 ? 0 : result;
                return result.toFixed(2);
            },
            hashData: function () {
                return JSON.stringify(this.existingReview);
            }   
            //getDollarAmmountFromTotal: function () {
            //    {
            //        if (this.existingReview.isPercentAmountAllocation) {
            //            return this.existingReview.projectAmountAllocations.map((p) => {
            //                p.percentAmountDollarValue = this.summaryCosts.totalReimbursementAmount * (p.allocationValue / 100);
            //                return p
            //            })
            //        }
            //    }
            //}
        },
        data: function () {
            return {
                currencyOptions: [
                    { text: '$', value: false },
                    { text: '%', value: true }
                ],
                expenseReportStatusTypeId: 1,
                expenseReportStatusTypeName: "",
                show_modal: false,
                expenseReportID: null,
                snapShots: null,
                summaryCosts: {},
                lastReviewSubmission: {},
                projects: [],
                selectedProject: {},
                existingReview: {
                    expenseReportId: this.$route.params.erid,
                    generalComment: "",
                    isPercentAmountAllocation: false,
                    hasForfeitedExpenditureCancellation: false,
                    forfeitedExpenditureCancellationComment: "",
                    hasMinimizeCosts: true,
                    hasMinimizeCostsComment: "",
                    projectAmountAllocations: [
                    ],
                    foreignExchangeAmounts: [
                    ],
                    generalAttachments: [
                    ],
                    foreignExchangeAttachments: [
                    ],
                    id: null //not updating an existing submission
                },
                currency: {
                    "AED": "United Arab Emirates Dirham",
                    "AFN": "Afghan Afghani",
                    "ALL": "Albanian Lek",
                    "AMD": "Armenian Dram",
                    "ANG": "Netherlands Antillean Guilder",
                    "AOA": "Angolan Kwanza",
                    "ARS": "Argentine Peso",
                    "AUD": "Australian Dollar",
                    "AWG": "Aruban Florin",
                    "AZN": "Azerbaijani Manat",
                    "BAM": "Bosnia-Herzegovina Convertible Mark",
                    "BBD": "Barbadian Dollar",
                    "BDT": "Bangladeshi Taka",
                    "BGN": "Bulgarian Lev",
                    "BHD": "Bahraini Dinar",
                    "BIF": "Burundian Franc",
                    "BMD": "Bermudan Dollar",
                    "BND": "Brunei Dollar",
                    "BOB": "Bolivian Boliviano",
                    "BRL": "Brazilian Real",
                    "BSD": "Bahamian Dollar",
                    "BTC": "Bitcoin",
                    "BTN": "Bhutanese Ngultrum",
                    "BWP": "Botswanan Pula",
                    "BYN": "Belarusian Ruble",
                    "BZD": "Belize Dollar",
                    "CAD": "Canadian Dollar",
                    "CDF": "Congolese Franc",
                    "CHF": "Swiss Franc",
                    "CLF": "Chilean Unit of Account (UF)",
                    "CLP": "Chilean Peso",
                    "CNH": "Chinese Yuan (Offshore)",
                    "CNY": "Chinese Yuan",
                    "COP": "Colombian Peso",
                    "CRC": "Costa Rican Colón",
                    "CUC": "Cuban Convertible Peso",
                    "CUP": "Cuban Peso",
                    "CVE": "Cape Verdean Escudo",
                    "CZK": "Czech Republic Koruna",
                    "DJF": "Djiboutian Franc",
                    "DKK": "Danish Krone",
                    "DOP": "Dominican Peso",
                    "DZD": "Algerian Dinar",
                    "EGP": "Egyptian Pound",
                    "ERN": "Eritrean Nakfa",
                    "ETB": "Ethiopian Birr",
                    "EUR": "Euro",
                    "FJD": "Fijian Dollar",
                    "FKP": "Falkland Islands Pound",
                    "GBP": "British Pound Sterling",
                    "GEL": "Georgian Lari",
                    "GGP": "Guernsey Pound",
                    "GHS": "Ghanaian Cedi",
                    "GIP": "Gibraltar Pound",
                    "GMD": "Gambian Dalasi",
                    "GNF": "Guinean Franc",
                    "GTQ": "Guatemalan Quetzal",
                    "GYD": "Guyanaese Dollar",
                    "HKD": "Hong Kong Dollar",
                    "HNL": "Honduran Lempira",
                    "HRK": "Croatian Kuna",
                    "HTG": "Haitian Gourde",
                    "HUF": "Hungarian Forint",
                    "IDR": "Indonesian Rupiah",
                    "ILS": "Israeli New Sheqel",
                    "IMP": "Manx pound",
                    "INR": "Indian Rupee",
                    "IQD": "Iraqi Dinar",
                    "IRR": "Iranian Rial",
                    "ISK": "Icelandic Króna",
                    "JEP": "Jersey Pound",
                    "JMD": "Jamaican Dollar",
                    "JOD": "Jordanian Dinar",
                    "JPY": "Japanese Yen",
                    "KES": "Kenyan Shilling",
                    "KGS": "Kyrgystani Som",
                    "KHR": "Cambodian Riel",
                    "KMF": "Comorian Franc",
                    "KPW": "North Korean Won",
                    "KRW": "South Korean Won",
                    "KWD": "Kuwaiti Dinar",
                    "KYD": "Cayman Islands Dollar",
                    "KZT": "Kazakhstani Tenge",
                    "LAK": "Laotian Kip",
                    "LBP": "Lebanese Pound",
                    "LKR": "Sri Lankan Rupee",
                    "LRD": "Liberian Dollar",
                    "LSL": "Lesotho Loti",
                    "LYD": "Libyan Dinar",
                    "MAD": "Moroccan Dirham",
                    "MDL": "Moldovan Leu",
                    "MGA": "Malagasy Ariary",
                    "MKD": "Macedonian Denar",
                    "MMK": "Myanma Kyat",
                    "MNT": "Mongolian Tugrik",
                    "MOP": "Macanese Pataca",
                    "MRO": "Mauritanian Ouguiya (pre-2018)",
                    "MRU": "Mauritanian Ouguiya",
                    "MUR": "Mauritian Rupee",
                    "MVR": "Maldivian Rufiyaa",
                    "MWK": "Malawian Kwacha",
                    "MXN": "Mexican Peso",
                    "MYR": "Malaysian Ringgit",
                    "MZN": "Mozambican Metical",
                    "NAD": "Namibian Dollar",
                    "NGN": "Nigerian Naira",
                    "NIO": "Nicaraguan Córdoba",
                    "NOK": "Norwegian Krone",
                    "NPR": "Nepalese Rupee",
                    "NZD": "New Zealand Dollar",
                    "OMR": "Omani Rial",
                    "PAB": "Panamanian Balboa",
                    "PEN": "Peruvian Nuevo Sol",
                    "PGK": "Papua New Guinean Kina",
                    "PHP": "Philippine Peso",
                    "PKR": "Pakistani Rupee",
                    "PLN": "Polish Zloty",
                    "PYG": "Paraguayan Guarani",
                    "QAR": "Qatari Rial",
                    "RON": "Romanian Leu",
                    "RSD": "Serbian Dinar",
                    "RUB": "Russian Ruble",
                    "RWF": "Rwandan Franc",
                    "SAR": "Saudi Riyal",
                    "SBD": "Solomon Islands Dollar",
                    "SCR": "Seychellois Rupee",
                    "SDG": "Sudanese Pound",
                    "SEK": "Swedish Krona",
                    "SGD": "Singapore Dollar",
                    "SHP": "Saint Helena Pound",
                    "SLL": "Sierra Leonean Leone",
                    "SOS": "Somali Shilling",
                    "SRD": "Surinamese Dollar",
                    "SSP": "South Sudanese Pound",
                    "STD": "São Tomé and Príncipe Dobra (pre-2018)",
                    "STN": "São Tomé and Príncipe Dobra",
                    "SVC": "Salvadoran Colón",
                    "SYP": "Syrian Pound",
                    "SZL": "Swazi Lilangeni",
                    "THB": "Thai Baht",
                    "TJS": "Tajikistani Somoni",
                    "TMT": "Turkmenistani Manat",
                    "TND": "Tunisian Dinar",
                    "TOP": "Tongan Pa'anga",
                    "TRY": "Turkish Lira",
                    "TTD": "Trinidad and Tobago Dollar",
                    "TWD": "New Taiwan Dollar",
                    "TZS": "Tanzanian Shilling",
                    "UAH": "Ukrainian Hryvnia",
                    "UGX": "Ugandan Shilling",
                    "USD": "United States Dollar",
                    "UYU": "Uruguayan Peso",
                    "UZS": "Uzbekistan Som",
                    "VEF": "Venezuelan Bolívar Fuerte",
                    "VND": "Vietnamese Dong",
                    "VUV": "Vanuatu Vatu",
                    "WST": "Samoan Tala",
                    "XAF": "CFA Franc BEAC",
                    "XAG": "Silver Ounce",
                    "XAU": "Gold Ounce",
                    "XCD": "East Caribbean Dollar",
                    "XDR": "Special Drawing Rights",
                    "XOF": "CFA Franc BCEAO",
                    "XPD": "Palladium Ounce",
                    "XPF": "CFP Franc",
                    "XPT": "Platinum Ounce",
                    "YER": "Yemeni Rial",
                    "ZAR": "South African Rand",
                    "ZMW": "Zambian Kwacha",
                    "ZWL": "Zimbabwean Dollar"
                },
                show_modal_remove: false,
                itemToRemove: null,
                attachmentToRemove: null,
                itemTypeToRemove: null,
                ItemRemoveType: {
                    ExchangeAttachment: 0,
                    CurrencyAmount: 1,
                    GeneralAttachment: 2,
                    ProjectType: 3
                },      
                hash: null,
                show_save_modal: false,
            }
        },
        methods: {
            removeItem(itemType, index, attachIndex) {
                switch (itemType) {
                    case 0:
                        this.removeExchangeAttachment(index);
                        break;
                    case 1:
                        this.removeCurrencyAmount(index);
                        break;
                    case 2:
                        this.removeGeneralAttachment(index);
                        break;
                    case 3:
                        this.RemoveProjectFromAllocationList(index);
                        break;
                    default:
                        break;
                }
                this.show_modal_remove = false;
            },
            showRemovalModal(itemType, index, attachIndex) {
                this.itemToRemove = index;
                this.itemTypeToRemove = itemType;
                this.attachmentToRemove = attachIndex;
                this.show_modal_remove = true;
            },
            downloadFileInNewWindow(params) {
                console.log(params)
                let documentType = 'receipts/';
                if (params.attachmentTypeId == 2) {
                    documentType = 'InstitutionalDocuments/'
                }
                this.$http
                    .get(documentType + params.attachmentId + '/Download', {
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        const downloadUrl = window.URL.createObjectURL(file);
                        window.open(downloadUrl);
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            translateCurrencyToPercentOrDollars() {
                if (!this.existingReview.isPercentAmountAllocation) {

                    this.existingReview.projectAmountAllocations.forEach((p) => {
                        let percentage = p.allocationValue / this.summaryCosts.totalReimbursementAmount;
                        //p.allocationValue = Math.round(percentage * 100);
                        let result = (percentage * 100).toFixed(2);
                        p.allocationValue = isNaN(result) || !isFinite(result) ? 0.00 : result;
                    })
                } else {

                    // bool value to keep track of if rounding up has occurred
                    // mathmatical error occurs from rounding up all values
                    var roundUp = true;

                    this.existingReview.projectAmountAllocations.forEach((p) => {
                        //convert to percentage
                        let percentage = p.allocationValue * .01;
                        let calculatedAllocation = (percentage * this.summaryCosts.totalReimbursementAmount);
                        let roundedUpValue = calculatedAllocation.toFixed(2);
                        let roundedDownValue = Math.floor((calculatedAllocation * 100)) / 100;

                        // if we are to round up, but the value should be rounded down (< 5), then use Math.Floor
                        if (roundUp && roundedDownValue != roundedUpValue) {
                            p.allocationValue = roundedUpValue;
                            roundUp = false;
                        } else {
                            p.allocationValue = roundedDownValue
                            roundUp = true;
                        }
                    })
                }
            },
            getExisitingReview(erid) {
                this.$http
                    .get(`expensereports/${erid}/submission`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.existingReview = response.data;
                        this.getProjects();
                        this.hash = this.hashData;
                    })
                    .catch(error => {
                        this.getProjects();
                    })
            },
            async submitApproval() {
                try {
                    await ApprovalService.submitApproval(this.expenseReportID);
                    const redirect = await ApprovalService.getRedirectURL(this.expenseReportStatusTypeId);
                    this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Approval request sent successfully." });
                    let expenseReportStatus = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                    this.expenseReportStatusTypeId = expenseReportStatus.expenseReportStatusTypeId;
                    this.expenseReportStatusTypeName = expenseReportStatus.expenseReportStatusTypeName;
                    if(redirect)
                        this.$router.push(redirect)
                } catch (e) {
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                }
            },
            async deny() {
                try {
                    await ApprovalService.deny(this.expenseReportID);
                    this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Approval request sent successfully." });
                    let expenseReportStatus = await TripProfileService.getExpenseReportStatus(this.expenseReportID);
                    this.expenseReportStatusTypeId = expenseReportStatus.expenseReportStatusTypeId;
                    this.expenseReportStatusTypeName = expenseReportStatus.expenseReportStatusTypeName;
                } catch (e) {
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                }
            },
            addProjectToAllocationList() {
                this.existingReview.projectAmountAllocations.push({
                    expenseReportSubmissionId: null,
                    projectId: null,
                    allocationValue: (isNaN(this.projectAllocationsDiff) ? 0 : this.projectAllocationsDiff),
                    id: null
                })
            },
            addCurrencyAmount() {
                this.existingReview.foreignExchangeAmounts.push({
                    expenseReportSubmissionId: null,
                    amount: null,
                    foreignCurrency: null,
                    id: null
                })
            },
            removeCurrencyAmount(cAINDEX) {
                this.existingReview.foreignExchangeAmounts.splice(cAINDEX, 1)
            },
            removeExchangeAttachment(eAINDEX) {
                this.existingReview.foreignExchangeAttachments.splice(eAINDEX, 1)
            },
            removeGeneralAttachment(gAINDEX) {
                this.existingReview.generalAttachments.splice(gAINDEX, 1)
            },
            RemoveProjectFromAllocationList(pAIndex) {
                this.existingReview.projectAmountAllocations.splice(pAIndex, 1);
            },
            async getProjects() {
                try {
                    const data = await ProjectService.getUserProjects(this.existingReview ? this.existingReview.createdByUserId : null);
                    data.forEach(d => d.projectName = `${d.projectNumber} - ${d.projectName}`);
                    this.projects = data;
                } catch {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: error
                    });
                    this.errored = true
                }
            },
            isValid() {
                //TODO: Implement validation
                //summaryCosts.totalReimbursementAmount
                if (this.isSumProjectAllocationNotEqualsTotal) {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: 'Sum of Project Allocations does not equal total.'
                    });
                    return false;
                }
                return true;
            },
            submitReview() {
                this.hideConfirmModal();
                if (this.isValid()) {
                    this.$http
                        .post('expensereports/Submission', this.existingReview, {
                            headers: {
                                "Authorization": "Bearer " + this.msal.accessToken
                            }
                        })
                        .then(response => {
                            //this.$notify({
                            //    group: 'success',
                            //    type: 'success ',
                            //    title: 'Success',
                            //    text: "Review submitted successfully"
                            //});
                            this.show_modal = true
                        })
                        .catch(error => {
                            let guiError = error;
                            if (error.response.data) {
                                guiError = error.response.data.join("<br>")
                            }
                            this.$notify({
                                group: 'errors',
                                type: 'error',
                                title: 'Error',
                                text: guiError
                            });
                            this.errored = true
                        })
                }
            },
            save() {
                // don't check sum of project when saving
                //if (this.isValid()) {
                this.hash = this.hashData;
                    this.$http
                        .post('expensereports/Submission/Save', this.existingReview, {
                            headers: {
                                "Authorization": "Bearer " + this.msal.accessToken
                            }
                        })
                        .then(response => {
                            this.$notify({
                                group: 'success',
                                type: 'success ',
                                title: 'Success',
                                text: "Review saved successfully"
                            });
                            window.scrollTo(0, 0);
                        })
                        .catch(error => {
                            let guiError = error;
                            if (error.response.data) {
                                guiError = error.response.data.join("<br>")
                            }
                            this.$notify({
                                group: 'errors',
                                type: 'error',
                                title: 'Error',
                                text: guiError
                            });
                            this.errored = true
                        })
                        .finally(()=>
                        {
                            this.show_save_modal = false;
                        })
                //}
            },
            submitReviewPreCheck() {
                if (this.isValid()) {
                    // check for null projectId
                    this.existingReview.projectAmountAllocations.forEach((p) => {
                        if (p.projectId == null) {
                            this.$notify({
                                group: 'errors',
                                type: 'error',
                                title: 'Error',
                                text: 'The ProjectId field is required for submission'
                            });
                            this.errored = true
                        }
                    })

                    if (this.errored) {
                        return;
                    }

                    let projectIds = [];
                    this.existingReview.projectAmountAllocations.forEach((p) => {
                        projectIds.push(p.projectId)
                    })

                    this.$http
                        .post('expensereports/' + this.existingReview.expenseReportId + '/submission/checkdates', projectIds, {
                            headers: {
                                "Authorization": "Bearer " + this.msal.accessToken
                            }
                        })
                        .then(response => {
                            if (response && response.data) {
                                this.$bvModal.show('confirm-submit-modal');
                            }
                            else {
                                this.submitReview();
                            }
                        })
                        .catch(error => {
                            let guiError = error;
                            if (error.response.data) {
                                guiError = error.response.data.join("<br>")
                            }

                            this.$notify({
                                group: 'errors',
                                type: 'error',
                                title: 'Error',
                                text: guiError
                            });

                            this.errored = true
                        })
                }
            },
            getExisitingReviewSubmission(erID) {
                this.$http
                    .get(`expensereports/${erID}/Submission`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.lastReviewSubmission = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            getSummaryCosts(erID) {
                this.$http
                    .get(`expensereports/${erID}/Review`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.summaryCosts = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            hideConfirmModal() {
                this.$bvModal.hide('confirm-submit-modal');
            }
        },
        async beforeRouteLeave(to, from, next) {

            if (this.$data.hash !== this.hashData) {
                this.show_save_modal = true;
            }
            else {
                console.log("Data has not changed");
                next();
            }       
        }
    }
</script>
